"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const core_1 = require("@sentry/core");
const react_1 = require("react");
const ErrorPage_1 = __importDefault(require("../../lib/errors/ErrorPage"));
const ErrorTypes_1 = require("../../lib/errors/ErrorTypes");
class HelpPageErrorBoundary extends react_1.Component {
    constructor(props = {}) {
        super(props);
        this.state = { error: undefined };
    }
    static getDerivedStateFromError(error) {
        return { error };
    }
    componentDidCatch(error) {
        if (error.capture) {
            (0, core_1.captureException)(error);
        }
    }
    render() {
        var _a;
        const error = (_a = this.state) === null || _a === void 0 ? void 0 : _a.error;
        if (!error) {
            return this.props.children;
        }
        if (error instanceof ErrorTypes_1.PageNotFoundError) {
            return ((0, jsx_runtime_1.jsx)(ErrorPage_1.default, Object.assign({ stretchHeight: false, action: {
                    to: "/help",
                    label: "Help Center",
                } }, { children: error.message })));
        }
        else if (error instanceof ErrorTypes_1.UserError) {
            return ((0, jsx_runtime_1.jsx)(ErrorPage_1.default, Object.assign({ action: "contact", stretchHeight: false }, { children: error.message })));
        }
        else {
            return ((0, jsx_runtime_1.jsx)(ErrorPage_1.default, Object.assign({ action: "contact", stretchHeight: false }, { children: "An unexpected error ocurred." })));
        }
    }
}
exports.default = HelpPageErrorBoundary;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSGVscFBhZ2VFcnJvckJvdW5kYXJ5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvaGVscC9IZWxwUGFnZUVycm9yQm91bmRhcnkudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBLHVDQUFnRDtBQUNoRCxpQ0FBa0M7QUFDbEMsMkVBQW1EO0FBQ25ELDREQUEyRTtBQU0zRSxNQUFxQixxQkFBc0IsU0FBUSxpQkFHbEQ7SUFDQyxZQUFZLEtBQUssR0FBRyxFQUFFO1FBQ3BCLEtBQUssQ0FBQyxLQUFLLENBQUMsQ0FBQztRQUNiLElBQUksQ0FBQyxLQUFLLEdBQUcsRUFBRSxLQUFLLEVBQUUsU0FBUyxFQUFFLENBQUM7SUFDcEMsQ0FBQztJQUVELE1BQU0sQ0FBQyx3QkFBd0IsQ0FBQyxLQUFVO1FBQ3hDLE9BQU8sRUFBRSxLQUFLLEVBQUUsQ0FBQztJQUNuQixDQUFDO0lBRUQsaUJBQWlCLENBQUMsS0FBVTtRQUMxQixJQUFJLEtBQUssQ0FBQyxPQUFPLEVBQUU7WUFDakIsSUFBQSx1QkFBZ0IsRUFBQyxLQUFLLENBQUMsQ0FBQztTQUN6QjtJQUNILENBQUM7SUFFRCxNQUFNOztRQUNKLE1BQU0sS0FBSyxHQUFHLE1BQUEsSUFBSSxDQUFDLEtBQUssMENBQUUsS0FBSyxDQUFDO1FBQ2hDLElBQUksQ0FBQyxLQUFLLEVBQUU7WUFDVixPQUFPLElBQUksQ0FBQyxLQUFLLENBQUMsUUFBUSxDQUFDO1NBQzVCO1FBRUQsSUFBSSxLQUFLLFlBQVksOEJBQWlCLEVBQUU7WUFDdEMsT0FBTyxDQUNMLHVCQUFDLG1CQUFTLGtCQUNSLGFBQWEsRUFBRSxLQUFLLEVBQ3BCLE1BQU0sRUFBRTtvQkFDTixFQUFFLEVBQUUsT0FBTztvQkFDWCxLQUFLLEVBQUUsYUFBYTtpQkFDckIsZ0JBRUEsS0FBSyxDQUFDLE9BQU8sSUFDSixDQUNiLENBQUM7U0FDSDthQUFNLElBQUksS0FBSyxZQUFZLHNCQUFTLEVBQUU7WUFDckMsT0FBTyxDQUNMLHVCQUFDLG1CQUFTLGtCQUFDLE1BQU0sRUFBQyxTQUFTLEVBQUMsYUFBYSxFQUFFLEtBQUssZ0JBQzdDLEtBQUssQ0FBQyxPQUFPLElBQ0osQ0FDYixDQUFDO1NBQ0g7YUFBTTtZQUNMLE9BQU8sQ0FDTCx1QkFBQyxtQkFBUyxrQkFBQyxNQUFNLEVBQUMsU0FBUyxFQUFDLGFBQWEsRUFBRSxLQUFLLGtEQUVwQyxDQUNiLENBQUM7U0FDSDtJQUNILENBQUM7Q0FDRjtBQW5ERCx3Q0FtREMifQ==